import { Component } from '@angular/core';

@Component({
  selector: 'app-project-list-wrapper',
  templateUrl: './project-list-wrapper.component.html',
  styleUrls: ['./project-list-wrapper.component.scss'],
})
export class ProjectListWrapperComponent {
}
